module.exports = __webpack_public_path__ + "img/bsidd-4.40349484.webp";